var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCountdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1045_8066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.65625 7.69454C1.09524 7.61529 1.54045 7.57551 1.98654 7.57568C3.79225 7.57568 5.44596 8.21911 6.73396 9.28997",
    stroke: "black",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79911 12.1473H1.79911C1.496 12.1473 1.20531 12.0269 0.990985 11.8126C0.776658 11.5983 0.65625 11.3076 0.65625 11.0045V1.86161C0.65625 1.5585 0.776658 1.26781 0.990985 1.05349C1.20531 0.839158 1.496 0.71875 1.79911 0.71875H10.942C11.2451 0.71875 11.5358 0.839158 11.7501 1.05349C11.9644 1.26781 12.0848 1.5585 12.0848 1.86161V5.86161",
    stroke: "black",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22545 6.43283C7.60433 6.43283 7.96769 6.28232 8.2356 6.01441C8.50351 5.7465 8.65402 5.38314 8.65402 5.00426C8.65402 4.62537 8.50351 4.26201 8.2356 3.9941C7.96769 3.72619 7.60433 3.57568 7.22545 3.57568C6.84657 3.57568 6.4832 3.72619 6.21529 3.9941C5.94738 4.26201 5.79688 4.62537 5.79688 5.00426C5.79688 5.38314 5.94738 5.7465 6.21529 6.01441C6.4832 6.28232 6.84657 6.43283 7.22545 6.43283ZM8.3843 12.0717C7.98316 12.002 7.98316 11.426 8.3843 11.3563C9.09457 11.2326 9.75194 10.9003 10.2726 10.4016C10.7932 9.90296 11.1536 9.26053 11.3077 8.55626L11.3317 8.4454C11.4186 8.04883 11.9832 8.04654 12.0734 8.44197L12.1032 8.57111C12.2632 9.2722 12.6268 9.91037 13.1484 10.4055C13.6699 10.9006 14.3261 11.2306 15.0346 11.354C15.438 11.4248 15.438 12.0031 15.0346 12.074C14.3261 12.1972 13.6698 12.5272 13.1482 13.0223C12.6267 13.5174 12.2631 14.1557 12.1032 14.8568L12.0734 14.986C11.9832 15.3814 11.4186 15.3791 11.3317 14.9825L11.3077 14.8717C11.1536 14.1674 10.7932 13.525 10.2726 13.0263C9.75194 12.5276 9.09457 12.1953 8.3843 12.0717Z",
    stroke: "black",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1045_8066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountdownIcon);
export default __webpack_public_path__ + "static/media/countdown-icon.7a8e4ac8b3a7da85530d2c8eb460c028.svg";
export { ForwardRef as ReactComponent };